import { useParams } from "react-router-dom";
import AddEditSalaryComponentForm from "../../../components/sections/companySettings/salaryStructure/AddEditSalaryComponentForm";
import BreadCrumbs from "../../../components/ui/BreadCrumbs";
import useAddEditSalaryComponent from "../../../hooks/companySettings/salaryStructure/useAddEditSalaryComponent";
import useGetSalaryComponent from "../../../hooks/companySettings/salaryStructure/useGetSalaryComponent";
import FullScreenLoader from "../../../components/loader/FullScreenLoader";

const breadcrumbs = [
  {
    label: "Company Settings",
    link: "/company-settings",
  },
  {
    label: "Salary Structure",
    link: "/company-settings/salary-structure",
  },
  {
    label: "Edit Salary Component",
    link: "",
  },
];

const EditSalaryComponent = () => {
  const { id } = useParams();
  const {
    control,
    watch,
    handleSubmit,
    setValue,
    addComponent,
    editComponent,
    isAdding,
    isEditing,
    // Derived options
    derivedOptions,
    hasMore,
    fetchNextDerivedOptions,
  } = useAddEditSalaryComponent({ componentIdForEdit: id });

  const { isDataLoading } = useGetSalaryComponent({
    componentId: id,
    onSuccess: (data) => {
      const resData = data.data;
      setValue("component_id", resData.component_id);
      setValue("name", resData.name);
      setValue(
        "derived_from",
        resData.derived_from?.map?.((el) => {
          return {
            label: el.name,
            value: el.component_id,
          };
        }) || []
      );
      setValue("from_ctc", resData.from_ctc);
      setValue("pro_rata", resData.pro_rata);
      setValue("calculation_type", resData.calculation_type);
      setValue("name_in_payslip", resData.name_in_payslip);
      setValue("value", resData.value);
      setValue("epf_type", resData.epf_type);
      setValue("consider_for_epf", resData.consider_for_epf);
      setValue("consider_for_esi", resData.consider_for_esi);
      setValue("show_in_payslip", resData.show_in_payslip);
    },
  });

  return (
    <div className="px-5">
      <BreadCrumbs crumbs={breadcrumbs} />

      <div className="flex justify-between items-center mb-6 mt-6">
        <h1 className=" text-xl font-bold ">Edit Earning Component</h1>
      </div>

      {isDataLoading && <FullScreenLoader />}

      <AddEditSalaryComponentForm
        isEdit={true}
        control={control}
        watch={watch}
        handleSubmit={handleSubmit}
        addComponent={addComponent}
        setValue={setValue}
        editComponent={editComponent}
        isAdding={isAdding}
        isEditing={isEditing}
        derivedOptions={derivedOptions}
        hasMore={hasMore}
        fetchNextDerivedOptions={fetchNextDerivedOptions}
      />
    </div>
  );
};

export default EditSalaryComponent;
